import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { MarkedCompanyJobs } from '@/features/marked-company-jobs'

const searchSchema = z.object({
  company: z.string().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/company-jobs/marked/'
)({
  validateSearch: searchSchema,
  component: MarkedCompanyJobs,
})
